import Vue from 'vue'

const els = document.querySelectorAll('.team-member')
if (els != null) {
  els.forEach((el) => {
    var vm = new Vue({
      data: () => {
        return {
          panelIsOpen: false
        }
      },
      delimiters: ['[[', ']]'],
      methods: {
        toggleOpen () {
          this.panelIsOpen = !this.panelIsOpen
        }
      },
      watch: {
        panelIsOpen: {
          handler: function (val) {
            this.$nextTick(() => {
              if (typeof this.$refs.closeBtn !== 'undefined') {
                this.$refs.closeBtn.focus()
              }
            })
          },
          deep: true
        }
      }
    })
    vm.$mount(el)

    if (window.location.hash && window.location.hash.split('#')[1] === el.id) {
      vm.panelIsOpen = true
    }
  })
}
